/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { ItamPermissionsBoundaryTenantContextQuery } from '@jira/itam__tenant-context/src/__generated__/ItamPermissionsBoundaryTenantContextQuery.graphql.ts';
import itamPermissionsParams from '@jira/itam__tenant-context/src/__generated__/ItamPermissionsBoundaryTenantContextQuery$parameters.ts';
import { getStaticPermissionChecks } from '@jira/itam__tenant-context/src/getStaticPermissionChecks.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ItamAiInsightsPreviewEntryPointComponent = EntryPointComponent<
	{ itamPermissions: ItamPermissionsBoundaryTenantContextQuery },
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const itamAiInsightsPreviewEntryPoint: EntryPoint<
	ItamAiInsightsPreviewEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ItamAiInsightsPreviewEntryPointComponent>(
		/* webpackChunkName: "async-itam-ai-insights-preview-entrypoint", jiraSpaEntry: "async-itam-ai-insights-preview-entrypoint" */ './ItamAiInsightsPreviewPage.tsx',
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => {
		return {
			entryPoints: {},
			queries: {
				itamPermissions: {
					parameters: itamPermissionsParams,
					variables: { cloudId, staticChecks: getStaticPermissionChecks(cloudId) },
					options: { fetchPolicy: 'store-or-network' as const },
				},
			},
		};
	},
});
